// For chromium
// https://source.chromium.org/chromium/chromium/src/+/master:third_party/blink/renderer/modules/permissions/permission_descriptor.idl?originalUrl=https:%2F%2Fcs.chromium.org%2Fchromium%2Fsrc%2Fthird_party%2Fblink%2Frenderer%2Fmodules%2Fpermissions%2Fpermission_descriptor.idl
module.exports = Object.freeze({
  GEOLOCATION: "geolocation",
  NOTIFICATION: "notifications",
  PUSH: "push",
  MIDI: "midi",
  CAMERA: "camera",
  MICROPHONE: "microphone",
  BACKGROUND_FETCH: "background-fetch",
  BACKGROUND_SYNC: "background-sync",
  PERSISTANT_STORAGE: "persistent-storage",
  AMBIANT_LIGHT_SENSOR: "ambient-light-sensor",
  ACCELEROMETER: "accelerometer",
  GYROSCOPE: "gyroscope",
  MAGNETOMETER: "magnetometer",
  SCREEN_WIDE_LOCK: "screen-wake-lock",
  NFC: "nfc",
  DISPLAY_CAPTURE: "display-capture",
  SPEAKER: "speaker",
  DEVICE_INFO: "device-info",
  BLUETOOTH: "bluetooth",
  CLIPBOARD: "clipboard",
});
